// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__+2TuN","delayed":"LoadingScreen_delayed__UWNW3","cssAnimation":"LoadingScreen_cssAnimation__-8ZTi"};